import { message } from 'antd'
import { uninvoiceRetentionPayment } from '../../../../../HttpRequests/retentionPayments'
import fetchProject from '../../../Services/fetchProject'
import handleException from '../../../../../Core/Helpers/handleException'

export default (id) => async (dispatch) => {

  try {

    await uninvoiceRetentionPayment({ id })

    await dispatch(fetchProject())

    message.success('Undone Invoice')
    
  } catch (error) {

    handleException(error)

  }
  
}